import { OutboundLink } from "./Map";

export const TaxExemptions = ({ bbl, referrer }) => {
  const receivesJ51 = BuildingsWithJ51.includes(bbl);
  const receives421a = BuildingsWith421a.includes(bbl);

  return (
    <p className="chart-note">
      Current tax exemptions:{" "}
      <b>
        {receives421a && (
          <OutboundLink
            className="button"
            to="https://www.thecity.nyc/housing/2022/2/10/22925482/a-tenants-guide-to-421-a-the-citys-biggest-tax-break-for-developers-and-landlords"
            referrer={referrer}
          >
            421a ↗
          </OutboundLink>
        )}

        {receivesJ51 && (
          <OutboundLink
            className="button"
            to="https://www.nyc.gov/site/finance/benefits/benefits-j51.page"
            referrer={referrer}
          >
            J-51 ↗
          </OutboundLink>
        )}

        {!receives421a && !receivesJ51 && "none"}
      </b>
    </p>
  );
};

// Tax abatement data comes from CoreData.nyc (https://furmancenter.org/coredata/userguide/data-downloads)
// Joined directly with buildings.json

const BuildingsWithJ51 = [
  1017080048, 1017720057, 1018300063, 1019040003, 1019130039, 1019220024,
  1019260009, 1019870034, 1020350001, 1022180048, 2023880010, 2024070025,
  2024530045, 2025060033, 2028790204, 2029500072, 2029720038, 2032940008,
  2032950056, 2033010037, 2033150076, 2037440019, 2042560014, 3001870016,
  3011817502, 3012090033, 3012480047, 3015080065, 3015850036, 3016200048,
  3016630086, 3018100051, 3025230020, 3031740022, 3032070016, 3032110013,
  3032650057, 3033120031, 3033220012, 3034290002, 3034350053, 3036100034,
  3036210035, 3040870010, 3045960042, 3046050019, 3050470006, 3051360059,
  3058160068, 4090990007, 1003730023, 1005050026, 1005520036, 1006200013,
  1007740056, 1008180008, 1008880044, 1011507504, 1012030117, 1016100064,
  1016250070, 1016310025, 1016320027, 1016350144, 1016380052, 1016390133,
  1017260009, 1017260039, 1017700023, 1017720017, 1017720020, 1018210004,
  1018210049, 1018220041, 1018300064, 1018300163, 1018310018, 1018310116,
  1018360019, 1018360020, 1018420047, 1018460041, 1018460056, 1018470054,
  1018470059, 1018490020, 1018490043, 1018877501, 1019010012, 1019010015,
  1019010019, 1019040004, 1019050002, 1019070104, 1019130028, 1019130030,
  1019130035, 1019220006, 1019230060, 1019240021, 1019240064, 1019250029,
  1019270052, 1019270055, 1019400019, 1019400128, 1019430047, 1019470018,
  1019470019, 1019470020, 1019470046, 1019470047, 1019480020, 1019500064,
  1019530001, 1019580037, 1019870033, 1019870036, 1020090047, 1020110050,
  1020120022, 1020120057, 1020130012, 1020140003, 1020260041, 1020300010,
  1020310017, 1020340038, 1020410031, 1020410068, 1020440013, 1020450057,
  1020480046, 1020810006, 1020980040, 1021100008, 1021110064, 1021220140,
  1021370086, 1021590025, 1021610055, 1021610064, 1021610110, 1021680066,
  1021700292, 1021700420, 1021740085, 1021740111, 1021740182, 1021770136,
  1021800173, 1022370036, 2022650035, 2023010040, 2023880011, 2023990020,
  2024460011, 2024460037, 2024500036, 2024520051, 2024550018, 2024560171,
  2024600030, 2024610040, 2024650001, 2024720001, 2024720023, 2024730001,
  2024760047, 2024760050, 2024760091, 2024860030, 2024880046, 2025070024,
  2025070029, 2025100087, 2025210031, 2025240021, 2025280028, 2025370036,
  2025500017, 2026150050, 2026150053, 2026230151, 2026530053, 2026620023,
  2026630007, 2026630009, 2026630013, 2026630031, 2026660022, 2026760065,
  2026830051, 2026890044, 2027030030, 2027030032, 2027070022, 2027260066,
  2027400012, 2027540063, 2027540064, 2027620164, 2027620166, 2027630144,
  2027860030, 2028050031, 2028050065, 2028200001, 2028260051, 2028280017,
  2028290068, 2028320050, 2028410001, 2028480020, 2028670155, 2028720123,
  2028720256, 2028760165, 2028770290, 2029370025, 2029450027, 2029470007,
  2029480008, 2029480047, 2029500001, 2029500070, 2029520012, 2029530048,
  2029580062, 2029610018, 2030880017, 2030890055, 2031020035, 2031140001,
  2031190007, 2031190064, 2031240066, 2031280027, 2031580001, 2032090021,
  2032100059, 2032120026, 2032140001, 2032140066, 2032150063, 2032400037,
  2032480136, 2032480140, 2032530091, 2032560176, 2032760005, 2032880025,
  2032920068, 2032920070, 2033020046, 2033050055, 2033060053, 2033200028,
  2037150017, 2037440014, 2037440024, 2037440029, 2037440034, 2037740016,
  2037760029, 2038100013, 2039060055, 2039250028, 2039297501, 2039377501,
  2039387501, 2039437501, 2039820035, 2040070037, 2042560008, 2043170046,
  2044280001, 2044280052, 2044280056, 2045470042, 2045700039, 2045950026,
  2045970031, 2048210051, 2048250051, 2048490079, 2048500051, 2049950011,
  2057850284, 2059111102, 2059190436, 2059200653, 2059500429, 3001640034,
  3001870014, 3001940061, 3002590008, 3003950057, 3004370039, 3006480042,
  3008210016, 3008290061, 3008320001, 3011330043, 3011410045, 3011410050,
  3011460004, 3011550012, 3011550023, 3011680082, 3011750045, 3011870058,
  3011870059, 3012240032, 3012240066, 3012280051, 3012350023, 3012400004,
  3012400005, 3012400008, 3012430016, 3012430032, 3012480057, 3012530031,
  3012707503, 3012870027, 3012930038, 3013190006, 3013200005, 3013400041,
  3013630048, 3013630050, 3013760054, 3013870001, 3013870044, 3013870057,
  3013930001, 3014180049, 3014420020, 3014470013, 3014500004, 3014710046,
  3014710052, 3014750001, 3014810051, 3014830046, 3014850020, 3014860017,
  3014910024, 3014910040, 3014910041, 3014910049, 3014910052, 3014970065,
  3015010033, 3015080053, 3015090055, 3015100023, 3015100024, 3015100030,
  3015100045, 3015140006, 3015220061, 3015220064, 3015330048, 3015340025,
  3015340039, 3015420061, 3015600023, 3015740016, 3015990005, 3016070045,
  3016090020, 3016090029, 3016200042, 3016200043, 3016220079, 3016270053,
  3016390043, 3016480017, 3016630076, 3016630084, 3016630088, 3016640053,
  3016780001, 3017730006, 3017760043, 3017760044, 3017770068, 3018110019,
  3018130016, 3018250003, 3018260022, 3018280089, 3018310001, 3018310005,
  3018310067, 3018370053, 3018410006, 3018480001, 3018510055, 3018630026,
  3018710010, 3019607501, 3019820007, 3019820077, 3023487501, 3024410024,
  3025050002, 3026210048, 3026890069, 3027777502, 3031310019, 3031340040,
  3031350015, 3031360001, 3031580050, 3031650028, 3031730018, 3031730020,
  3031840012, 3031870026, 3031870036, 3031880006, 3031940021, 3031960023,
  3031960027, 3031960035, 3032080012, 3032110003, 3032110010, 3032110012,
  3032110015, 3032300003, 3032340037, 3032350013, 3032430078, 3032430079,
  3032450037, 3032460050, 3032470026, 3032560026, 3032570023, 3032650058,
  3032650059, 3032650060, 3032650069, 3032790012, 3032800005, 3032850082,
  3032890014, 3033050069, 3033060021, 3033230032, 3033230038, 3033350040,
  3033400003, 3033680038, 3033740031, 3033750031, 3033780005, 3033780011,
  3033840037, 3033910028, 3033920056, 3033920065, 3033990016, 3033990020,
  3034060048, 3034060052, 3034170010, 3034170025, 3034180033, 3034200042,
  3034230043, 3034250062, 3034260019, 3034290026, 3034300032, 3034300042,
  3034300044, 3034330011, 3034340002, 3034350032, 3034350051, 3034360047,
  3034410002, 3034410011, 3034470006, 3034560043, 3035900011, 3035900050,
  3036130047, 3038070042, 3038220006, 3039500041, 3040660023, 3042980064,
  3043030029, 3043030030, 3043110020, 3043110023, 3044560065, 3049320019,
  3050630029, 3050660001, 3051000056, 3051250045, 3051250047, 3051250048,
  3051250049, 3051250079, 3051260054, 3051280001, 3051710083, 3051890042,
  3052060017, 3052080046, 3052100006, 3052130019, 3052210043, 3052300072,
  3052520039, 3053440040, 3053990001, 3055900064, 3056600072, 3056760027,
  3057600007, 3064140062, 3072797501, 3086850070, 3087160064, 4006340007,
  4012650030, 4012650033, 4012740020, 4014440032, 4014460045, 4014510012,
  4014510047, 4014680001, 4015090052, 4015530028, 4029740060, 4034360011,
  4049560013, 4062060001, 4065370028, 4084010096, 4084400001, 4084420001,
  4084460001, 4084500001, 4130120013,
];

const BuildingsWith421a = [
  1007080020, 1007297502, 1010210001, 1010330001, 1011710157, 1016670042,
  1017367502, 1019880018, 2022870002, 2024420034, 2026760130, 2028500052,
  2030970010, 2032670034, 2032770012, 2035970040, 2036600024, 2036600122,
  2039640024, 2039750039, 2040530047, 2043230050, 2048350186, 3001210012,
  3001667502, 3008187501, 3008900073, 3009490065, 3011430035, 3012310042,
  3012607501, 3013340047, 3013540074, 3014810053, 3016070074, 3016990027,
  3017120039, 3017680046, 3017700048, 3017710005, 3017720003, 3022507503,
  3025307501, 3026240045, 3030320025, 3031710065, 3033457501, 3034190028,
  3047920038, 3048697501, 3048840062, 3049980008, 3050300051, 3051080062,
  3051317501, 3060860082, 3075600041, 4005680106, 4006460027, 4006490064,
  4006590068, 4013080019, 4017180035, 4017760005, 4018920080, 4019280016,
  4019410042, 4033210379, 4097120159, 5000440015, 1003467501, 1003527501,
  1003550054, 1004417504, 1007017501, 1007330008, 1007757502, 1008340069,
  1009337501, 1010450006, 1010450012, 1010710042, 1010720001, 1010817501,
  1010897502, 1010907502, 1011040031, 1011057501, 1011710063, 1011717509,
  1016240015, 1016380008, 1016390057, 1016600024, 1016600038, 1016610024,
  1016810031, 1017160051, 1017240105, 1017260132, 1018310023, 1018790136,
  1019110001, 1019280005, 1022180035, 2022930052, 2023480015, 2023667501,
  2023730006, 2024110139, 2024420060, 2025150003, 2025200053, 2025230165,
  2025270001, 2025517501, 2025680073, 2026077501, 2026270001, 2026400050,
  2026620028, 2026760134, 2026760136, 2026900134, 2026900173, 2026940019,
  2027180021, 2027350042, 2028260034, 2028500023, 2029720007, 2029740023,
  2030220029, 2030650031, 2030930047, 2031110039, 2032400059, 2032400060,
  2032830025, 2032840040, 2033970019, 2036600022, 2036600023, 2036600025,
  2036600028, 2036600029, 2036600051, 2036600053, 2036600057, 2036600059,
  2038450043, 2039340024, 2039640016, 2039640018, 2039640022, 2039640025,
  2039640035, 2039640036, 2039640037, 2039640131, 2039640132, 2039640133,
  2039670034, 2039700034, 2039850027, 2039850028, 2041747502, 2042350020,
  2042490039, 2043230051, 2043230052, 2044330037, 2045090044, 2045457501,
  2045710043, 2045710044, 2046460021, 2046460022, 2046490084, 2046610068,
  2046650126, 2046670059, 2046670060, 2046770117, 2046790082, 2048260038,
  2048350182, 2052600024, 2052600026, 2054790048, 2057087501, 3002260030,
  3002440026, 3022410036, 3003090022, 3003967504, 3004010041, 3006310078,
  3006370019, 3022660017, 3007280021, 3007760067, 3008680056, 3008910025,
  3008910058, 3008990022, 3010400048, 3011180002, 3011410076, 3011490017,
  3011490034, 3011740049, 3012110075, 3012310041, 3012310043, 3012560011,
  3013340045, 3013340046, 3013540082, 3013550022, 3013850069, 3014030030,
  3015720039, 3015740019, 3015790046, 3016010020, 3016010120, 3016030010,
  3016050007, 3016070073, 3016070075, 3016230033, 3016230039, 3022637511,
  3016320007, 3016330025, 3016420037, 3016530180, 3016590035, 3016590036,
  3016620059, 3016870068, 3016870069, 3016910010, 3017040010, 3017040036,
  3017310030, 3017430016, 3017540017, 3017540033, 3017547502, 3017547505,
  3017590072, 3017620055, 3017630012, 3017710011, 3017740044, 3017750023,
  3017750056, 3017810048, 3017820018, 3017850011, 3017880040, 3017910074,
  3017940053, 3018000019, 3018000020, 3018590022, 3018890023, 3018890025,
  3018920074, 3018990009, 3018990058, 3019000009, 3019000067, 3019140135,
  3019287502, 3019337501, 3019700034, 3020120001, 3020150023, 3020160012,
  3020290049, 3020290051, 3021280005, 3021340056, 3022187505, 3022890014,
  3023040015, 3023467502, 3023580024, 3023710034, 3023947502, 3023960012,
  3024160001, 3024320002, 3024607501, 3024640030, 3024640032, 3025130018,
  3025320024, 3025510040, 3025710001, 3025980030, 3026590042, 3026900070,
  3026900071, 3027220010, 3027280024, 3027450032, 3027600015, 3027620015,
  3027740031, 3027760024, 3027800005, 3027870025, 3028570027, 3028570106,
  3028660021, 3029070021, 3029070023, 3029160032, 3029160033, 3029160052,
  3029160053, 3029170007, 3029190020, 3029190027, 3029200016, 3030320026,
  3030320028, 3030400005, 3030440010, 3030440014, 3030490125, 3030490126,
  3030520005, 3030620029, 3030700023, 3030790014, 3031207501, 3031390021,
  3031620042, 3031700009, 3031700019, 3031700026, 3031710018, 3031720010,
  3031720044, 3031720047, 3031840060, 3031840062, 3031860049, 3031860051,
  3032040024, 3032070051, 3032320074, 3032430054, 3032640018, 3032660023,
  3032680011, 3032680012, 3032750036, 3032750037, 3032750039, 3032840026,
  3033540007, 3033540009, 3033860041, 3034170044, 3034180034, 3034190009,
  3034190027, 3034320042, 3034510009, 3040880019, 3040880020, 3047930051,
  3047930053, 3047950001, 3048060077, 3048090021, 3048840061, 3050070062,
  3050080034, 3050080035, 3050300033, 3050300034, 3050300052, 3050390055,
  3050470017, 3050470018, 3050470076, 3050470176, 3050560012, 3050620061,
  3050630015, 3050660068, 3050820032, 3050850094, 3051080026, 3051080061,
  3051100068, 3051110020, 3051640043, 3051710036, 3052060050, 3052270013,
  3052740009, 3054007501, 3054580049, 3055910059, 3056100026, 3056590042,
  3056590043, 3057070033, 3057820041, 3058680009, 3067050058, 3067390047,
  3067407501, 3067460037, 3067660086, 3067680017, 3067830055, 3067837501,
  3069160025, 3070210020, 3071037501, 3071620075, 3075600040, 3075610017,
  3075620051, 3075620052, 3076560058, 3078000039, 3086630246, 3086640470,
  3086670725, 3087070411, 3088100096, 4000330010, 4000330011, 4000330012,
  4002670009, 4003290139, 4003687501, 4003777501, 4004240025, 4004337501,
  4005020041, 4005070019, 4005150001, 4005310050, 4005330037, 4005350029,
  4005350051, 4005400018, 4005400021, 4005400040, 4005490036, 4005520018,
  4005670129, 4005680206, 4005940029, 4005940051, 4005970110, 4005980001,
  4005980038, 4005980064, 4005980076, 4006160030, 4006330003, 4006490074,
  4006520042, 4006570010, 4006600027, 4006610013, 4006610037, 4008090055,
  4008450015, 4008920113, 4008990058, 4008990182, 4009000053, 4013010016,
  4013100077, 4013110074, 4013210019, 4014650036, 4014920043, 4014970051,
  4015190061, 4015280088, 4015930018, 4016060050, 4016090038, 4017180034,
  4017390022, 4017430006, 4017480005, 4017480052, 4017530031, 4017530032,
  4017530088, 4017530091, 4017740030, 4017760006, 4017760058, 4017850008,
  4017850022, 4017850046, 4018350062, 4018380057, 4018380059, 4018387505,
  4018390033, 4018920081, 4019060026, 4019060128, 4019060129, 4019060131,
  4019350012, 4019410039, 4019410041, 4019500178, 4019560001, 4019570001,
  4019780015, 4019820037, 4019830049, 4019970071, 4020040059, 4020100063,
  4020100064, 4020110029, 4020110030, 4021100041, 4027280026, 4028810047,
  4028810049, 4028810050, 4028810051, 4028810052, 4029000027, 4034280001,
  4034320038, 4034950056, 4035670016, 4049520035, 4049610013, 4051400040,
  4052950008, 4053330008, 4067980005, 4067997502, 4068000072, 4068000073,
  4097130152, 4097937501, 4099150001, 4099440014, 4099740035, 4115590038,
  4125290238, 4159100025, 4159150063, 5000160031, 5005930735, 5005930740,
  3075610018,
];
